/**
 * 模块说明：大目录管理
 */
import { Service } from '@/tools'
export class Directory<T extends TOrder.Directory> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Directory}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Bookmenu}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }
  private postUpload1<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Directory}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }
  /** 功能：编辑目录 */
  updateDirectory = <K extends T['ApiUpdateDirectory']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateDirectory', data)

  /**功能：查看未被引用品种信息*/
  unQuoteInfo = <K extends T['ApiUnQuoteInfo']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUnQuoteInfo', data)

  /** 功能：不符合下发小目录明细*/
  unAccordIssuedSmallInfo = <K extends T['ApiUnAccordIssuedSmallInfo']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiUnAccordIssuedSmallInfo', data)

  /** 功能：停用 */
  stopUsing = <K extends T['ApiStopUsing']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiStopUsing', data)

  /** 功能：启用   */
  startUsing = <K extends T['ApiStartUsing']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiStartUsing', data)

  /** 功能：分批查询大目录列表 */
  page = <K extends T['ApiPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  /** 功能：大目录发布   */
  issued = <K extends T['ApiIssued']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiIssued', data)

  /** 功能：查看目录详情   */
  detail = <K extends T['ApiDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)

  /** 功能：删除目录   */
  delete = <K extends T['ApiDelete']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiDelete', data)

  /** 功能：大目录撤销发布   */
  cancelIssued = <K extends T['ApiCancelIssued']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiCancelIssued', data)

  /** 功能：新增目录   */
  addDirectory = <K extends T['ApiAddDirectory']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddDirectory', data)

  /** 功能：新增目录   */
  getLastDirectory = <K extends T['ApiLastDirectory']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiLastDirectory', data || {})

  /** 功能：新增目录   */
  getLastDirectoryPage = <K extends T['ApiLastDirectoryPage']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiLastDirectoryPage', data || {})

  /** 功能：获取下拉框列表（新增小目录）   */
  getDirectoryDropDown = <K extends T['ApiDirectoryDropDown']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiDirectoryDropDown', data)

  /** 功能：获取下拉框列表加分页加模糊搜索       */
  getDirectoryDropDownPage = <K extends T['ApiDirectoryDropDownPage']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiDirectoryDropDownPage', data)
  /** 功能：查询所有基层店   */
  getGrassRootsStores = <K extends T['ApiGrassRootsStores']>(): Promise<K['res']> => this.post2('v1/ApiGrassRootsStores')

  /** 功能：根据大目录信息查询商品列表   */
  selectBooksByBigDirectory = <K extends T['ApiSelectBooksByBigDirectory']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectBooksByBigDirectory', data)

  /** 功能：备货初始化   */
  initialization = <K extends T['ApiInitialization']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiInitialization', data)

  /** 功能：目录复制   */
  copyDirectory = <K extends T['ApiCopyDirectory']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiCopyDirectory', data)
  /** 关联目录
   * /api/order/directory/v1/connectDirectory
   */
  connectDirectory = <K extends T['ApiConnectDirectory']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiConnectDirectory', data)
  /* 导入核价  */
  importExcel = <K extends T['ApiImportExcel']>(data?: K['req']): Promise<K['res']> => this.postUpload('v1/ApiImportExcel', data)
  /** 导入文件  */
  bookImport = <K extends T['ApiBookImport']>(data?: K['req']): Promise<K['res']> => this.postUpload1('v1/ApiBookImport', data)
  /** 添加核价
   * /api/order/directory/v1/addDirectoryPrice
   */
  addDirectoryPrice = <K extends T['ApiAddDirectoryPrice']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddDirectoryPrice', data)

  /**
   * 人工备货-添加商品
   * /api/order/directory/v1/querySupplierDirectory
   */
  querySupplierDirectory = <K extends T['ApiQuerySupplierDirectory']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQuerySupplierDirectory', data)

  /* 下发明细-大目录详情  */
  issuedInfo = <K extends T['ApiIssuedInfo']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiIssuedInfo', data)

   /* 查询大目录下发的基层店列表
   /api/order/directory/v1/queryOrgCompany
   */
  queryOrgCompany = <K extends T['ApiQueryOrgCompany']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryOrgCompany', data)
  /* 下发明细-基层店信息分页  */
  issuedInfoPage = <K extends T['ApiIssuedInfoPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiIssuedInfoPage', data)
  /* 大目录撤销发布单-新 */
  bigCancelIssued = <K extends T['ApiBigCancelIssued']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBigCancelIssued', data)
  /* 大目录发布 重新下发单独 -新 */
  bigIssued = <K extends T['ApiBigIssued']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBigIssued', data)
  /* 大目录发布-批量新   */
  bigBatchIssued = <K extends T['ApiBigBatchIssued']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBigBatchIssued', data)
  /* 大目录撤销发布-批量新   */
  bigBatchCancelIssued = <K extends T['ApiBigBatchCancelIssued']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiBigBatchCancelIssued', data)

  //教材征订提醒目录筛选
  // /api/order/directory/v1/directoryTextbookPage
  directoryTextbookPage = <K extends T['ApiDirectoryTextbookPage']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiDirectoryTextbookPage', data)


}
